import { useFileBrowserStore } from '../stores/fileBrowserStore'

export function FileBreadcrumb() {
  const { currentPath, navigateTo, currentGroupId, currentGroupName, currentGroupRole, currentGroupPerms } = useFileBrowserStore()
  const parts = currentPath.replace(/\/$/, '').split('/').filter(Boolean)

  const goToRoot = () => {
    useFileBrowserStore.setState({
      currentGroupId: 0, currentGroupName: '', currentGroupRole: '', currentGroupPerms: 0,
    })
    navigateTo('/')
  }

  const goToSegment = (index: number) => {
    if (index === 0) {
      navigateTo('/' + parts[0] + '/', currentGroupId, currentGroupName, currentGroupRole, currentGroupPerms)
    } else {
      const path = '/' + parts.slice(0, index + 1).join('/') + '/'
      navigateTo(path)
    }
  }

  return (
    <nav className="breadcrumb" data-testid="breadcrumb">
      <button onClick={goToRoot}>🏠 Home</button>
      {parts.map((seg, i) => (
        <span key={i}>
          <span className="sep">/</span>
          {i < parts.length - 1 ? (
            <button onClick={() => goToSegment(i)}>{decodeURIComponent(seg)}</button>
          ) : (
            <span className="current">{decodeURIComponent(seg)}</span>
          )}
        </span>
      ))}
    </nav>
  )
}
